/** Sturges bin count, clamped [3, 50] */
export function sturgesBinCount(n) {
  return Math.min(50, Math.max(3, Math.ceil(Math.log2(Math.max(n, 1)) + 1)));
}

/**
 * Assigns each value to a bin. Returns { binnedLabels, binEdges, assignedBins }.
 * Empty bins in binnedLabels get zero counts from downstream.
 */
export function binValues(values, binCount) {
  if (!values.length) return { binnedLabels: [], binEdges: [], assignedBins: [] };
  const nums = values.map(Number).filter(v => !isNaN(v));
  if (!nums.length) return { binnedLabels: [], binEdges: [], assignedBins: values.map(() => null) };
  const min = Math.min(...nums);
  const max = Math.max(...nums);
  if (min === max) {
    const lbl = `[${min.toFixed(2)}, ${max.toFixed(2)}]`;
    return { binnedLabels: [lbl], binEdges: [min, max], assignedBins: nums.map(() => lbl) };
  }
  const width = (max - min) / binCount;
  const edges = Array.from({ length: binCount + 1 }, (_, i) => min + i * width);
  const labels = Array.from({ length: binCount }, (_, i) =>
    `[${edges[i].toFixed(2)}, ${edges[i+1].toFixed(2)})`
  );
  const assignedBins = nums.map(v => {
    let idx = Math.floor((v - min) / width);
    if (idx >= binCount) idx = binCount - 1;
    return labels[idx];
  });
  return { binnedLabels: labels, binEdges: edges, assignedBins };
}
